var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterVerticalFulfilment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83203 17.5V15",
    stroke: "#2C3A4B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.168 17.5V12.5",
    stroke: "#2C3A4B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.168 5V2.5",
    stroke: "#2C3A4B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83203 7.5V2.5",
    stroke: "#2C3A4B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83203 15C5.05546 15 4.66718 15 4.36089 14.8732C3.95251 14.704 3.62806 14.3795 3.4589 13.9712C3.33203 13.6648 3.33203 13.2766 3.33203 12.5C3.33203 11.7234 3.33203 11.3352 3.4589 11.0288C3.62806 10.6205 3.95251 10.296 4.36089 10.1268C4.66718 10 5.05546 10 5.83203 10C6.6086 10 6.99688 10 7.30317 10.1268C7.71155 10.296 8.03601 10.6205 8.20516 11.0288C8.33203 11.3352 8.33203 11.7234 8.33203 12.5C8.33203 13.2766 8.33203 13.6648 8.20516 13.9712C8.03601 14.3795 7.71155 14.704 7.30317 14.8732C6.99688 15 6.6086 15 5.83203 15Z",
    stroke: "#2C3A4B",
    strokeWidth: 1.25
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.168 10C13.3914 10 13.0031 10 12.6968 9.87317C12.2885 9.704 11.964 9.3795 11.7948 8.97117C11.668 8.66483 11.668 8.27657 11.668 7.5C11.668 6.72343 11.668 6.33515 11.7948 6.02886C11.964 5.62048 12.2885 5.29602 12.6968 5.12687C13.0031 5 13.3914 5 14.168 5C14.9446 5 15.3328 5 15.6391 5.12687C16.0475 5.29602 16.372 5.62048 16.5411 6.02886C16.668 6.33515 16.668 6.72343 16.668 7.5C16.668 8.27657 16.668 8.66483 16.5411 8.97117C16.372 9.3795 16.0475 9.704 15.6391 9.87317C15.3328 10 14.9446 10 14.168 10Z",
    stroke: "#2C3A4B",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterVerticalFulfilment);
export default __webpack_public_path__ + "static/media/filter-vertical-fulfilment.dcd22ccfc278928a4b950894960c9bdc.svg";
export { ForwardRef as ReactComponent };